import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormControllerService } from "../../../../../../services/form-controller/form-controller.service";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../../../pages/base-error";
import { DataMappingHelpers } from "../../../../../../models/data-mapping-helpers";
import { FieldGroup } from "../../../../../../models/field-group";
import { FormField } from "../../../../../../models/form-field";
import { ServiceField } from "../../../../../../models/service-field";

@Component({
  selector: "generic-sfl",
  templateUrl: "./generic-sfl.component.html",
  providers: [FormControllerService],
})
export class GenericSflComponent extends BaseError implements OnInit {

  @Input() public serviceId: string;
  @Input() public prefix: string = "";
  @Input() public gatherLinks: boolean = false;
  @Output() public cvfs = new EventEmitter();
  @Output() public isReady = new EventEmitter();
  @Output() public handleScroll = new EventEmitter();

  public allFields: any[] = [];
  public fields: any[] = [];
  public searchStringFormatted: string = "";
  public searchFields: string = "";
  public loadingFields: boolean = true;
  public links: any[] = [];

  constructor(
    private formControllerService: FormControllerService,
    public translate: TranslateService,
    public toastr: ToastrService,
  ) {
    super(toastr);
  }

  public ngOnInit(): void {
    this.loadAllFields();
  }

  public loadAllFields() {
    const components = [];
    this.formControllerService.getServiceFieldsWithCVF(this.serviceId).subscribe(
      (data) => {
        this.reloadFormArray(data.sort((a, b) => a.orderNumber - b.orderNumber ));
      },
      (error) => this.showErrorMessageWithTitle("Error when loading All Form Fields", error),
    );
  }

  public scroll() {
    this.handleScroll.emit();
    // this.updateLinesVisibility.emit();
}

  public reloadFormArray(forms: ServiceField[]): void {
    this.allFields = [];
    this.addItems(forms, null);
    forms.forEach((field) => {
        let fieldGroup = null;
        fieldGroup = new FieldGroup();
        fieldGroup.level = 1;
        this.parseChildren(field, fieldGroup, field.form, 0);
        fieldGroup.items = field.items;
        fieldGroup.groupName = field.form;
        fieldGroup.name = field.form;
        fieldGroup.orderNumber = field.orderNumber;
        this.allFields.push(fieldGroup);
    });
    this.buildTree();
  }

  private addItems(components: any[], formName: string) {
    components.forEach((field) => {
        if (field.fullKey) {
            field.key = field.fullKey;
        }
        if (field.formType) {
            formName = field.formType;
        }
        field.form = formName;
        if (field.components) {
            field.leaf = false;
            field.items = field.components;
            this.addItems(field.items, formName);
       } else {
           field.leaf = true;
       }
    });
  }

  public parseChildren(field: ServiceField, fieldGroup: any, fieldGroupName: string, lvl: number) {
    const formField = this.createFormField(field, lvl ? Number(lvl) + 1 : 1);
    formField.formTitle = fieldGroupName;
    fieldGroup.fields.push(formField);
    field.isgroup = !field.leaf;
    field.level = lvl ? Number(lvl) + 1 : 1;
    if (field.isgroup) {
      if (field.name == null) {
        field.name = "";
      }
      field.name = field.name.replace(" form page", "");
      field.tree = field.name;
    }
    field.fieldName = field.name;
    field.typeclass = DataMappingHelpers.getFieldClass(field.type, field.multiple);
    field.field = formField;
    if (field.items) {
        field.items.forEach((item) => {
            this.parseChildren(item, fieldGroup, fieldGroupName, field.level);
        });
    }
  }

  public createFormField(field: ServiceField, lvl) {
    const formField = new FormField();
    const fieldKey = field.key.replace(/,/g, "-");
    formField.fieldKey = field.key;
    formField.formTitle = field.form;
    formField.type = field.type;
    formField.copyValueFrom = field.copyValueFrom;
    if (this.gatherLinks && formField.copyValueFrom && formField.copyValueFrom.length) {
      this.links.push({
        field: field.key,
        cvf: field.copyValueFrom,
      });
    }
    formField.level = lvl;
    formField.orderNumber = field.orderNumber;
    formField.remoteType = this.setFieldRemoteType(field.type);
    if (field.name && field.name.toLocaleLowerCase() === "catalog") {
        field.name = "Value + internal key";
    }
    if (field.name && field.name.toLocaleLowerCase() === "key") {
        field.name = "Internal key";
        formField.type = "KEY";
        field.type = "KEY";
    }
    if (field.key && field.key.includes("CATALOG_EXTERNAL_KEY")) {
        formField.type = "KEY";
        field.type = "KEY";
    }
    if (field && field.name && field.name.startsWith("Role ")) {
        field.name = field.name.slice(4);
    }
    if (field.name && field.name.toLocaleLowerCase().includes("status") && field.type === "radio") {
      // formField.type = "boolean";
      // field.type = "boolean";
      formField.remoteType = "boolean";
  }
    formField.fieldName = field.name;
    formField.label = field.name;
    formField.filter = field.filter;
    if (formField.type === "CLASSIFICATION" || formField.type === "catalog" || formField.type === "KEY") {
        formField.filter = null;
        field.filter = null;
    }
    if (field.type === "htmlelement") {
        formField.inputHidden = true;
        formField.outputHidden = true;
    }
    if (formField.label && formField.label.indexOf("value to key") !== -1) {
        formField.inputHidden = true;
        formField.outputHidden = true;
    }
    if (formField.fieldKey && formField.fieldKey.indexOf("VALUE_TO_KEY") !== -1) {
        formField.inputHidden = false;
        formField.outputHidden = false;
    }
    return formField;
  }

  public orderGroupItems(group) {
    if (group && group.items && group.items.length) {
        group.items.sort((a, b) => {
            return a.orderNumber < b.orderNumber;
        });
        group.items.forEach((i) => {
            this.orderGroupItems(i);
        });
    }
  }

  public setFieldRemoteType(type: string) {
    if (type) {
        switch (type.toLowerCase()) {
            case "editgrid":
              return "editgrid";
            case "datagrid":
              return "datagrid";
            case "date":
            case "datetime":
            case "date-time":
                return "date";
            case "numeric":
            case "number":
            case "decimal":
            case "integer":
                return "Number";
            case "checkbox":
            // case "selectboxes":
            //     return "checkbox";
            case "boolean":
                return "Boolean";
            case "document":
            case "fileupload":
            case "file":
            case "requirement":
            case "result":
            case "fileupload":
                return "file";
            case "classification":
            case "catalog":
                return "catalog";
            // case "fileupload":
                // return "fileupload";
            case "radio":
                return "radio";
            // case "checkbox":
            case "selectboxes":
            case "text":
            case "string":
            case "textfield":
            case "mycontent":
            default:
                return "string";
        }
    } else {
        return "Text";
    }
  }

  public checkIfGroupExists(items: FieldGroup[], groupName: string): FieldGroup {
    let matchFieldGroup = null;
    if (items) {
        items.some((item) => {
            if (item.isgroup && item.groupName === groupName) {
                matchFieldGroup = item;
                return true;
            }
            matchFieldGroup = this.checkIfGroupExists(item.items, groupName);
            if (matchFieldGroup !== null) {
                return true;
            }
        });
    }
    return matchFieldGroup;
  }

  public getGroups(fields, isgroup): any[] {
    const nodes = [];
    fields.forEach((field) => {
            nodes.push({
                isgroup: isgroup ? isgroup : false,
                leaf: !isgroup ? true : false,
                field,
                typeclass: DataMappingHelpers.getFieldClass(field.type),
                name: field.label,
                title: field.label,
            });
    });
    return nodes;
  }

  public searchInItems(items, searchedString) {
    return items.some((i) => {
        const group = i.isgroup ? this.searchInItems(i.items, searchedString) : false;
        const name = i.name ? i.name.toLowerCase().includes(searchedString) : false;
        const outputName = i.outputName ? i.outputName.toLowerCase().includes(searchedString) : false;
        if (group) {
            i.items = this.filterItems(i.items, searchedString);
        }
        return (group + name + outputName);
    });
}

  public filterItems(items, searchedString) {
    return items.filter((it) => {
        const group = it.isgroup ? this.searchInItems(it.items, searchedString) : false;
        const name = it.name ? it.name.toLowerCase().includes(searchedString) : false;
        const outputName = it.outputName ? it.outputName.toLowerCase().includes(searchedString) : false;
        if (group) {
            it.items = this.filterItems(it.items, searchedString);
        }
        return (group + name + outputName);
    });
  }

  public searchInFields(value: any): void {
    this.searchStringFormatted = value.toLowerCase();
    if (value && value.length) {
        this.fields = this.filterItems(Object.assign(this.allFields), this.searchStringFormatted);
    } else {
        this.fields = Object.assign(this.allFields);
    }
  }

  public buildBranchesAndLeaves(branches: FieldGroup[]) {
      if (branches) {
          branches.forEach((branch) => {
              branch.items = branch.items ? branch.items : (branch.fields && this.getGroups(branch.fields, undefined));
              this.buildBranchesAndLeaves(branch.items);
          });
      }
  }

  public buildTree(): void {
    this.buildBranchesAndLeaves(this.allFields);
    this.fields = Object.assign(this.allFields);
    console.log(this.fields);
    if (this.gatherLinks) {
      this.cvfs.emit(this.links);
    }
    this.loadingFields = false;
    this.isReady.emit(true);
  }

}
